module.exports = __webpack_public_path__ + "static/media/link-logo-gbm.371bc24a.jpg";